const fixed_topic_part = 'SAS/Surf 1-3/';
const request_topic = '/Request';
const websocketport = '15675';
const finishedofalllivereadings = 'Close All';
const modetopic = 'Mode';
const changemodetopic = 'Change Mode ';
const readingcategorytopic = 'Readings Categories';
const diagram_topic = 'Diagram';
const stillpresent_topic = '/User Presence';
const Readings_topic = '/Readings/';
const sdformat_topic = 'SD Format';
const sdformatstatus_topic = '/SD Status';
const status_topic = 'Status';
const firmwareupdate_topic = '/Firmware Upgrade';
let choosenmac = '';
let choosenid = '';
let choosendevicefirmwaretype = '';
let mqttclientinstance = undefined;
let categories_User_Iswatching = [];
const parameters_category_command = 'Parameters Categories';
const cond05mac = '0-6d-52';//'0-67-2c';//'0-5a-48';'0-6d-52'
const requestdataforcond05intervalinmillisec = 5*60*1000;
let latitude = '';
let longitude = '';

const Parameters_topic = 'Parameters/';
const faults_topic = 'Faults/';
const faults_category = 'Faults Categories/';
const faults_display_command = 'Faults Display';
const readings_command = 'Readings/';
const reading_display_command = 'Readings Display/';
const parameters_command = 'Parameters/';
const parameters_display_command = 'Parameters Display/';
const id_not_ok = 'ID Not OK';//

let busy_Requesting_Data = false;
const timeouttotrytorequestmqttdata = 500;
let lasttimegotlivedata = 0;

module.exports = {busy_Requesting_Data,timeouttotrytorequestmqttdata,fixed_topic_part,request_topic,websocketport,
    finishedofalllivereadings,modetopic,changemodetopic,readingcategorytopic,diagram_topic,stillpresent_topic,Readings_topic,
    sdformat_topic,sdformatstatus_topic,lasttimegotlivedata,choosenmac,status_topic,mqttclientinstance,categories_User_Iswatching,
    parameters_category_command,choosenid,choosendevicefirmwaretype,cond05mac,requestdataforcond05intervalinmillisec,
    latitude,longitude,firmwareupdate_topic};